module.exports = __webpack_public_path__ + "static/media/(H)_MG_6047_-_Pro-Natura_-_Moda_Bebe.4b5bcfd6.jpg";